import React, { useEffect, useState } from 'react';
import { Typography, Grid, Box } from '@mui/material';
import { ReactComponent as WorldMap } from '../../data/clients/worldLow.svg';
import './ClientsMap.css';
import FlagIcon from 'react-flagkit';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const CountriesList = styled('ul')({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  listStyleType: 'none',
  padding: 0,
  margin: 0,
  gap: '10px',
});

const CountryItem = styled('li')({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 'normal',
  '&.highlighted': {
    fontWeight: 'bold',
  },
  cursor: 'pointer',
  transition: 'font-weight 0.3s ease',
});

const FlagWrapper = styled(Box)({
  marginRight: '10px',
});

const ClientsMap = () => {
  const [highlightedCountry, setHighlightedCountry] = useState(null);
  const { t } = useTranslation('experience');
  const countries = t('countries', { returnObjects: true });

  const handleMouseEnter = (countryCode) => {
    setHighlightedCountry(countryCode);
  };

  const handleMouseLeave = () => {
    setHighlightedCountry(null);
  };

  useEffect(() => {
    const svgCountries = document.querySelectorAll('.worldMap path');

    svgCountries.forEach((country) => {
      const countryCode = country.getAttribute('id');

      if (countries.some((c) => c.short === countryCode)) {
        country.classList.add('highlighted');
        country.addEventListener('mouseenter', () => setHighlightedCountry(countryCode));
        country.addEventListener('mouseleave', handleMouseLeave);
      }
    });

    return () => {
      svgCountries.forEach((country) => {
        country.removeEventListener('mouseenter', () => setHighlightedCountry(country.getAttribute('id')));
        country.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, [countries]);

  useEffect(() => {
    const svgCountries = document.querySelectorAll('.worldMap path');

    svgCountries.forEach((country) => {
      const countryCode = country.getAttribute('id');
      country.classList.remove('highlighted-hovered');
      if (countryCode === highlightedCountry) {
        country.classList.add('highlighted-hovered');
      }
    });
  }, [highlightedCountry]);

  return (
    <Grid container sx={{ alignItems: 'center' }}>
      <Grid item xs={12} lg={4}>
        <Typography sx={{ mb: 4 }}>{t('mapDescription')}</Typography>

        <CountriesList>
          {countries.map((country, index) => (
            <CountryItem
              key={index}
              onMouseEnter={() => handleMouseEnter(country.short)}
              onMouseLeave={handleMouseLeave}
              className={highlightedCountry === country.short ? 'highlighted' : ''}
            >
              <FlagWrapper>
                <FlagIcon country={country.short} size={25} />
              </FlagWrapper>
              {country.name}
            </CountryItem>
          ))}
        </CountriesList>
      </Grid>

      <Grid item xs={12} lg={8} sx={{ paddingX: 5 }}>
        <Box className="map-container">
          <WorldMap style={{ width: '100%', height: 'auto' }} />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ClientsMap;
